import React, {FC} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Checkbox} from '@optimaxdev/design-system';

import {CHECKOUT_DELIVERY_STEP} from 'constants/analytics/events/checkout';

import {managerNewsletterSubscription} from '../../utils/newsletterSubscription/managerNewsletterSubscription';

import {TermsAndPrivacy} from './termsAndPrivacy';

import s from './newsletterSubscription.scss';

type PropsType = {
    emailSubscription: {isChecked: boolean; isShown: boolean};
    isPhoneSubscriptionEnabled?: boolean | null;
    openTermsOfUse: () => void;
    openPrivacyPolicy: () => void;
    setEmailCheckbox: (value: boolean) => void;
    setSmsCheckbox: (value: boolean) => void;
    smsSubscription: {
        isChecked: boolean;
        isShown: boolean;
    };
};

const checkBoxHandler = (
    isChecked: boolean,
    setCheckbox: (arg0: boolean) => void,
    type: 'sms' | 'email',
) => {
    const value = !isChecked;
    managerNewsletterSubscription.setCheckboxValue(value);
    setCheckbox(value);
    sendDesktopAnalyticsEvent(CHECKOUT_DELIVERY_STEP, {
        message: `${value ? 'Accept' : 'Decline'} ${
            type === 'sms' ? 'SMS' : 'Email'
        } Communication - Checkbox`,
    });
};

/**
 *  SubscriptionText
 */
export const SubscriptionText: FC<PropsType> = ({
    emailSubscription,
    isPhoneSubscriptionEnabled,
    openPrivacyPolicy,
    openTermsOfUse,
    setEmailCheckbox,
    setSmsCheckbox,
    smsSubscription,
}) => {
    const smsSubscriptionContent = (
        <div className={s.checkbox}>
            <Checkbox
                onChange={() => {
                    if (isPhoneSubscriptionEnabled)
                        checkBoxHandler(smsSubscription.isChecked, setSmsCheckbox, 'sms');
                }}
                isChecked={smsSubscription.isChecked}
                size="small"
                value={String(smsSubscription.isChecked)}
                verticalAlign="center"
            >
                <span className={s.text}>
                    Text me updates about my orders, account and marketing promotions.{' '}
                </span>
            </Checkbox>
        </div>
    );
    const emailSubscriptionContent = (
        <div className={s.checkbox}>
            <Checkbox
                onChange={() => {
                    checkBoxHandler(emailSubscription.isChecked, setEmailCheckbox, 'email');
                }}
                isChecked={emailSubscription.isChecked}
                size="small"
                value={String(emailSubscription.isChecked)}
            >
                <span className={s.text}>
                    I agree to receive marketing updates and promotions via email.{' '}
                    <TermsAndPrivacy
                        openPrivacyPolicy={openPrivacyPolicy}
                        openTermsOfUse={openTermsOfUse}
                    />
                </span>
            </Checkbox>
        </div>
    );

    return (
        <div className={s.checkboxContainer}>
            {emailSubscription.isShown && emailSubscriptionContent}
            {isPhoneSubscriptionEnabled && smsSubscriptionContent}
        </div>
    );
};
